import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const CITIES = [
    { name: "Paris", coords: [48.8566, 2.3522] },
    { name: "Lyon", coords: [45.764, 4.8357] },
    { name: "Marseille", coords: [43.2965, 5.3698] },
    { name: "Lille", coords: [50.6292, 3.0573] },
    { name: "Bordeaux", coords: [44.8378, -0.5792] },
    { name: "Toulouse", coords: [43.6047, 1.4442] },
    { name: "Nantes", coords: [47.2184, -1.5536] },
    { name: "Strasbourg", coords: [48.5734, 7.7521] },
];

const goldPin = L.divIcon({
    className: "",
    html: '<span style="display:block;width:14px;height:14px;border-radius:9999px;background:#D4AF37;border:3px solid #0A0E17;box-shadow:0 0 0 4px rgba(212,175,55,0.3)"></span>',
    iconSize: [14, 14],
    iconAnchor: [7, 7],
});

export const FranceMap = () => (
    <div
        data-testid="france-map"
        className="relative z-0 rounded-2xl overflow-hidden border border-black/10 shadow-[0_20px_50px_rgba(10,14,23,0.15)]"
    >
        <MapContainer
            center={[46.7, 2.5]}
            zoom={5}
            zoomSnap={0.5}
            scrollWheelZoom={false}
            className="h-80 w-full"
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap"
            />
            {CITIES.map((city) => (
                <Marker key={city.name} position={city.coords} icon={goldPin}>
                    <Popup>
                        <strong>{city.name}</strong>
                        <br />
                        Intervention à domicile disponible
                    </Popup>
                </Marker>
            ))}
        </MapContainer>
    </div>
);
